import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import EditorCloseIcon from '@atlaskit/icon/core/cross';

interface CloseButtonProps {
	onClose?(): void;
}

export const CloseButton: React.ForwardRefExoticComponent<
	CloseButtonProps & React.RefAttributes<HTMLButtonElement>
> = React.forwardRef<HTMLButtonElement, CloseButtonProps>(({ onClose }, ref) => {
	return (
		<IconButton
			testId="sidebar-main-close-btn"
			label="Close"
			onClick={onClose}
			icon={EditorCloseIcon}
			ref={ref}
		/>
	);
});

CloseButton.displayName = 'CloseButton';
